import { render, staticRenderFns } from "./feedback-add.vue?vue&type=template&id=330a0302"
import script from "./feedback-add.vue?vue&type=script&lang=js"
export * from "./feedback-add.vue?vue&type=script&lang=js"
import style0 from "./feedback-add.vue?vue&type=style&index=0&id=330a0302&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports